export default "__VITE_ASSET__DIvShSLQ__"